import { Component, OnInit } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmationComponent } from "../../../common/components/confirmation/confirmation.component";
import { UserMgmtService } from "../user-management.service";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";

import { ExcelService } from "../../dashboard/excel.service";
import Swal from "sweetalert2";
import { RESPONSE } from "src/app/common/common.const";
import { Router, ActivatedRoute } from '@angular/router';
import { DataTableTranslations } from 'angular7-data-table';
@Component({
  selector: 'app-view-user-course',
  templateUrl: './view-user-course.component.html',
  styleUrls: ['./view-user-course.component.css']
})
export class ViewUserCourseComponent implements OnInit {
  closeResult: string;
  userDetails: object;

  userCourseList = [];
  userId: any;
  private modalRef: NgbModalRef;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };

  searchText: string = "";
  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private userMgmtService: UserMgmtService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,

    private ExcelService: ExcelService
  ) { }
  ngOnInit() {
    this.userId = this.route.snapshot.params["userId"];
    this.getUserList(this.userId);
  }

  getUserList(userId) {
    let query = "userId=" + userId;
    this.spinner.show();
    this.userMgmtService.getUserCourse(query).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.userCourseList = res.data;
        this.spinner.hide();

      } else {
        this.userCourseList = [];
      }
    });
    // this.spinner.hide();
  }


}
